import { getImageCrop } from "../helpers/ImageCrop.ts";
import { Event } from "../models/Event.tsx";
import { EventUmbraco } from "../models/Umbraco/Event.umb.tsx";
import { fetchUmbracoContent, formatTime } from "./utils";

export const EventApi = {
  async getCases(
    take?: number,
    skip?: number
  ): Promise<{
    total: number;
    items: Event[];
  }> {
    const data = await fetchUmbracoContent<EventUmbraco>("children:arrangementer", take, skip);
    
    const items = await Promise.all(data.items.map(async (item) => {
      const imageCrop = await getImageCrop(item);
      const startDate = new Date(item.properties.contentDetailsEventTimeFrom);
      const endTime = new Date(item.properties.contentDetailsEventTimeTo);

      return {
        iID: item.id,
        title: item.name,
        teaser: item.properties.contentSettingsTeaser,
        pictures: { threeTwo: imageCrop },
        link: item.route.path,
        place: item.properties.eventPlace,
        startTime: item.properties.contentDetailsEventTimeFrom,
        endTime: item.properties.contentDetailsEventTimeTo,
        formattedStartTime: formatTime(startDate),
        formattedEndTime: formatTime(endTime),
        startDatetoISOString: startDate,
        starteDateLocalString: startDate,
        startDate: startDate,
        EndDate: endTime,
      };
    }));

    return { items, total: data.total };
  },
};
